import { createLoader, create } from '../internal/hs-intl';
import createPublicI18nProvider from './createPublicI18nProvider';
function createAllI18nProvider(options) {
  const I18nProvider = options && options.shouldSetPublicI18n ? createPublicI18nProvider(options) : create();
  I18nProvider.register = function (lang, loadOptions = {}) {
    I18nProvider.langRegistry[lang.source] = lang;
    const provider = createLoader(lang, loadOptions.type);
    return provider.load(provider.locales, loadOptions).then(messages => {
      return messages;
    });
  };
  return I18nProvider;
}
export default createAllI18nProvider;